import { TuiFloatingContainer, TuiSlides } from '@taiga-ui/layout';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { Channel } from '@pixacare/chat';
import { PublicUser } from '@pixacare/domain';
import { DraftMessage } from '@shared/models/chat/draft-message';
import { TuiButton, TuiDialogContext, TuiInput, TuiLabel } from '@taiga-ui/core';
import { TuiStepper, TuiTextarea } from '@taiga-ui/kit';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { MessageWithReceivers } from 'src/app/shared/models/chat/message-with-receivers';
import { Size } from 'src/app/shared/models/enums/size.enum';
import { ReceiverListComponent } from '../receiver-list/receiver-list.component';
import { ReceiversPickerComponent } from '../receivers-picker/receivers-picker.component';
import { SlidesScrollResetDirective } from '@modules/shared/directives/slides-scroll-reset.directive';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';

enum SharePickerPage {
  SELECT_RECEIVERS,
  MESSAGE,
}

@Component({
  selector: 'pxc-share',
  imports: [
    EmptyStateComponent,
    SlidesScrollResetDirective,
    ReceiversPickerComponent,
    TuiStepper,
    TuiButton,
    TuiLabel,
    ReceiverListComponent,
    TuiTextarea,
    TuiInput,
    FormsModule,
    ReactiveFormsModule,
    TuiFloatingContainer,
    TuiSlides,
    TranslocoDirective,
  ],
  templateUrl: './share.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-1 flex-col' },
})
export class ShareComponent {
  private readonly context = inject<TuiDialogContext<DraftMessage, void>>(POLYMORPHEUS_CONTEXT);

  @Output() cancelAction = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<MessageWithReceivers>();

  channels: Channel[] = [];
  users: PublicUser[] = [];
  mailAddresses: string[] = [];

  shareText = new FormControl('');

  slideDirection = 0;
  private currentSharePage = SharePickerPage.SELECT_RECEIVERS;

  get currentPage(): SharePickerPage {
    return this.currentSharePage;
  }

  set currentPage(page: SharePickerPage) {
    this.slideDirection = page - this.currentSharePage;
    this.currentSharePage = page;
  }
  SharePickerPage = SharePickerPage;
  Size = Size;

  close(): void {
    this.context.completeWith(null);
    this.cancelAction.emit();
  }

  previous(): void {
    if (this.currentPage === SharePickerPage.MESSAGE) {
      this.currentPage = SharePickerPage.SELECT_RECEIVERS;
    }
  }

  next(): void {
    if (this.currentPage === SharePickerPage.SELECT_RECEIVERS) {
      this.currentPage = SharePickerPage.MESSAGE;
      return;
    }

    const newMessage: MessageWithReceivers = {
      text: this.shareText.value || '',
      receivers: {
        toChannelIds: this.channels.map((channel) => channel.id),
        toUserIds: this.users.map((user) => user.id),
        toMailAddresses: this.mailAddresses,
      },
    };

    this.confirm.emit(newMessage);
  }
}
